export default function Security() {
  return (
    <section id="security" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Your Privacy is Our Priority
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              At VOS-SYSTEM, we believe that online privacy is a fundamental right. Our VPN solution is built from the ground up with security and privacy at its core, ensuring your digital activities remain completely confidential.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg flex-shrink-0">
                  <i className="ri-lock-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Advanced Encryption Protocols
                  </h3>
                  <p className="text-gray-600">
                    We use industry-leading encryption standards including OpenVPN, IKEv2, and WireGuard to ensure your data remains secure and private at all times.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    DNS Leak Protection
                  </h3>
                  <p className="text-gray-600">
                    Our built-in DNS leak protection ensures that your browsing activity never leaks outside the encrypted VPN tunnel, maintaining complete anonymity.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-lg flex-shrink-0">
                  <i className="ri-refresh-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Automatic Kill Switch
                  </h3>
                  <p className="text-gray-600">
                    If your VPN connection drops unexpectedly, our kill switch immediately blocks all internet traffic to prevent any data leaks and protect your identity.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/d4956ba1b39751a51fd1cc4d31548801.jpg"
              alt="VPN Security"
              className="w-full h-auto rounded-2xl shadow-2xl object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
